"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useTranslation2 = _interopRequireDefault(require("next-translate/useTranslation"));
var translate = function translate(string) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _useTranslation = (0, _useTranslation2["default"])(),
    t = _useTranslation.t;
  return params ? t(string, params) : t(string);
};
var _default = translate;
exports["default"] = _default;